import { Box, MenuItem, SelectChangeEvent, Stack } from "@mui/material";
import { Field, useFormikContext } from "formik";
import { Select, TextField } from "formik-mui";
import BenutzerSelect from "../benutzer/BenutzerSelect";
import React from "react";
import { AbwesenheitDaten } from "../../api";

export default function AbwesenheitenFieldsContent({
  isVerwaltung,
  isNew,
}: {
  isVerwaltung: boolean;
  isNew: boolean;
}) {
  const { setFieldValue, values } = useFormikContext<AbwesenheitDaten>();
  const disabled = values.type === "Feiertag" && !isVerwaltung;
  return (
    <Stack direction="column">
      {isVerwaltung ? (
        <Box
          display={"grid"}
          sx={{ gridTemplateColumns: ["1fr", "1fr 1fr 1fr 1fr"], gap: 2 }}
        >
          <Field
            component={BenutzerSelect}
            label={"Mitarbeiter *"}
            name="mitarbeiter"
          />
        </Box>
      ) : (
        <></>
      )}
      <Box
        display={"grid"}
        sx={{ gridTemplateColumns: ["1fr", "1fr 1fr 1fr 1fr"], gap: 2, mt: 2 }}
      >
        <Field
          component={TextField}
          label={"Start *"}
          name="start"
          type="date"
          InputLabelProps={{ shrink: true }}
          disabled={disabled}
        />
        <Field
          component={TextField}
          label={"Ende *"}
          name="ende"
          type="date"
          InputLabelProps={{ shrink: true }}
          disabled={disabled}
        />
      </Box>
      <Box
        display={"grid"}
        sx={{ gridTemplateColumns: ["1fr", "1fr 1fr 1fr 1fr"], gap: 2, mt: 2 }}
      >
        <Field
          component={TextField}
          label={"Bemerkung"}
          name="bemerkung"
          disabled={disabled}
        />
        <Field
          name="type"
          component={Select}
          label={"Typ"}
          disabled={disabled}
          onChange={async (e: SelectChangeEvent) => {
            const typ = e.target.value;
            if (typ === "Urlaub") {
              await setFieldValue("brzKey", "U");
            }
            if (typ === "Krankmeldung") {
              await setFieldValue("brzKey", "K");
            }
            if (typ === "Arbeitszeitkonto") {
              await setFieldValue("brzKey", "");
            }
            if (typ === "Feiertag") {
              await setFieldValue("brzKey", "F");
            }
          }}
        >
          <MenuItem key="urlaub" value="Urlaub">
            Urlaub
          </MenuItem>
          <MenuItem key="krankmeldung" value="Krankmeldung">
            Krankheit
          </MenuItem>
          <MenuItem key="sonstiges" value="Sonstiges">
            Sonstige Abwesenheit
          </MenuItem>
          <MenuItem key="arbeitszeitkonto" value="Arbeitszeitkonto">
            Arbeitszeitkonto
          </MenuItem>
          {!isNew && (
            <MenuItem key="feiertag" value="Feiertag">
              Feiertag
            </MenuItem>
          )}
        </Field>
        <BrzKeySelect
          required={false}
          disabled={values.type === "Arbeitszeitkonto" || disabled}
          isNew={isNew}
        />
      </Box>
    </Stack>
  );
}

function BrzKeySelect({
  required = false,
  disabled = true,
  isNew,
}: {
  required: boolean;
  disabled: boolean;
  isNew: boolean;
}) {
  return (
    <Field
      name="brzKey"
      component={Select}
      label={`BRZ-Schlüssel ${required ? "*" : ""}`}
      disabled={disabled}
    >
      <MenuItem key="" value="">
        kein BRZ-Schlüssel
      </MenuItem>
      <MenuItem key="U" value="U">
        U: Urlaub
      </MenuItem>
      <MenuItem key="K" value="K">
        K: Krank
      </MenuItem>
      {!isNew && (
        <MenuItem key="F" value="F">
          F: Feiertag
        </MenuItem>
      )}
      <MenuItem key="TU" value="TU">
        TU: Tarifurlaub
      </MenuItem>
      <MenuItem key="UU" value="UU">
        UU: unbezahlter Urlaub
      </MenuItem>
      <MenuItem key="S" value="S">
        S: Sonderurlaub
      </MenuItem>
      <MenuItem key="FE" value="FE">
        FE: Fehlt entschuldigt
      </MenuItem>
      <MenuItem key="KU" value="KU">
        KU: Krank Unfall
      </MenuItem>
      <MenuItem key="KK" value="KK">
        KK: Krankenkasse Krankengeld
      </MenuItem>
      <MenuItem key="KB" value="KB">
        KB: Krankengeld nach Betriebsunfall
      </MenuItem>
      <MenuItem key="AU" value="AU">
        AU: Austeuerung
      </MenuItem>
      <MenuItem key="EU" value="EU">
        EU: Elternzeit / Urlaub
      </MenuItem>
      <MenuItem key="KI" value="KI">
        KI: Kindkrank
      </MenuItem>
    </Field>
  );
}
